<template>
  <div class="wrapper">
    <!-- 头部标题 -->
    <page-head title="环卫工作" :showBack="false"></page-head>
    <div class="content">
      <Tabs>
        <TabPane label="散煤复燃排查">
          <iframe
            class="iframebox"
            :style="{height:height+'px'}"
            :src="'http://shequyun.cn/decision/view/report?viewlet=/ct/smfrpc.cpt&communityId='+communityId"
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="餐饮油烟污染源信息">
          <iframe
          class="iframebox"
          :style="{height:height+'px'}"
          :src="'http://shequyun.cn/decision/view/report?viewlet=/ct/cycj.cpt&communityId='+communityId"
          frameborder="0"
          scrolling="no"
          ></iframe>
        </TabPane>
      </Tabs>
    </div>



  </div>
</template>

<script>
  import pageHead from '../../../components/head';
  export default {
    name: 'sanitation',
    components: {
      pageHead,
    },
    data () {
      return {
        communityId:this.$store.state.streetorcommunityid,
        head:'',
        height:'',
      }
    },
    mounted () {
      this.height= document.body.clientHeight-60 - 90-40-30;
      var head = location.origin
      if (head.indexOf('localhost') > -1) this.head = 'http://yanfa.shequyun.cn'
      else this.head = head
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ivu-tabs-nav .ivu-tabs-tab:hover{
    color:#ff7b44;
  }
  .wrapper{
    min-height: 100%;
    padding-bottom: 30px
  }
  .content{
    margin: 0 20px;
  }
  .iframebox{
    width: 100%;
    background: #fff;
  }
</style>
